import { render, staticRenderFns } from "./_base-input.vue?vue&type=template&id=5ec45028&scoped=true&"
import script from "./_base-input.vue?vue&type=script&lang=js&"
export * from "./_base-input.vue?vue&type=script&lang=js&"
import style0 from "./_base-input.vue?vue&type=style&index=0&id=5ec45028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec45028",
  null
  
)

export default component.exports